<template>
  <div>
    <h1 class="page-header">{{ $t('leaveRule.leaveRule') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-start">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="ts-flex-grow"></div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-input style="width:100%" v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'emp_type_name'
          }"
        >
          <template v-slot="{ record, index }">
            <td class="ts-whitespace-no-wrap">
              {{ record.leave_type.leave_type_en }} | {{ record.leave_type.leave_type_kh }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.total_day_allow }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.increment_day }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.increment_interval_year }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <span class="badge badge-success" v-if="record.allow_leave_when_no_balance">Yes</span>
              <span class="badge badge-default" v-else>No</span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.max_day_allow_carry_forward }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.in_month }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.cycle_start }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.cycle_stop }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.modified_by ? record.modified_by.full_name : '' }}</td>
            <td class="ts-whitespace-no-wrap text-center">{{ record.modified_date }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'leave-rule',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/leaveRule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.leaveRule.search
      },
      set(newValue) {
        this.$store.commit('hr/leaveRule/SET_SEARCH', newValue)
        this.$store.commit('hr/leaveRule/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('leaveRule.leaveType')
        },
        {
          name: this.$t('leaveRule.totalDayAllow'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.incrementDay'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.incrementIntervalYear'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.allowLeave'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.maxDayAllowCarryForward'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.carryForwardClearanceInMonth'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.cycleStart'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.cycleStop'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('leaveRule.modifiedBy')
        },
        {
          name: this.$t('leaveRule.modifiedDate'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 5%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/leaveRule/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '550px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/leaveRule/RESET_STATE')
    this.$store.commit('hr/leaveRule/SET_EMPLOYEE_TYPES', [])
    this.$store.commit('hr/leaveRule/SET_LEAVE_TYPES', [])
    next()
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
